var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "40px",
    viewBox: "0 0 50 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Tabs / Driver-Complete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.8227268,10.003659 C25.8227268,10.003659 24.4190073,15.3604583 24.7698578,18.4356579 C25.1207877,21.5108575 25.9279581,24.6852571 25.9279581,24.6852571 C25.9279581,24.6852571 25.0155563,19.1631509 25.0155563,17.1129649 C25.0155563,15.0628583 25.8227268,10.003659 25.8227268,10.003659 L25.8227268,10.003659 Z M17.0820969,24.5016974 C17.2363727,25.4271143 18.0074344,27.7406167 18.0074344,27.7406167 C18.0074344,27.7406167 18.5729537,23.9876034 17.801892,23.5248553 C17.0306716,23.0621866 16.7221993,21.8282974 16.7221993,21.8282974 C16.7221993,21.8282974 16.9278211,23.5762806 17.0820969,24.5016974 L17.0820969,24.5016974 Z M16.9896425,14.2847336 C16.6580765,16.1419161 16.7244214,20.3204576 16.7244214,20.3204576 C16.7244214,20.3204576 17.9845787,16.672517 18.3162241,16.4734821 C18.6478695,16.274606 18.6478695,14.7490689 18.6478695,14.7490689 L18.5151796,11.2337388 C18.5151796,11.2337388 17.3212879,12.4276305 16.9896425,14.2847336 L16.9896425,14.2847336 Z M32.5130914,15.608855 C32.4530952,16.4025343 32.375005,17.1947851 32.3079458,17.9879882 C32.296518,18.122424 32.3077871,18.2587645 32.3085807,18.3941526 C32.3222306,18.3943907 32.3360392,18.3946288 32.3497685,18.3949462 C32.414685,18.2728905 32.4796808,18.1507555 32.542772,18.0321917 C32.6502254,18.1057584 32.7271253,18.1584534 32.8041045,18.2110691 C33.0527393,18.2824931 33.0460731,18.5385878 33.1755092,18.7653986 C33.2186811,18.6542946 33.2549486,18.5910447 33.26717,18.5233507 C33.2947873,18.3693923 33.3137543,18.2135293 33.3308961,18.057825 C33.4171604,17.277875 33.3633543,16.5114162 33.0953556,15.768448 C32.9836961,15.4591821 32.7334741,15.2845901 32.4436514,15.1138868 C32.4718242,15.3017319 32.5245192,15.4577536 32.5130914,15.608855 L32.5130914,15.608855 Z M17.7538792,31.2324562 L17.4761192,31.1134162 C17.4761192,31.1134162 17.5157992,30.7562963 17.3967592,29.8833364 C17.2777193,29.0103765 17.148918,27.9111613 16.6428393,25.9946969 C16.1367607,24.0782325 15.8889194,20.5188576 16.0476394,16.0746982 C16.2063594,11.6305387 18.7855591,9.36877904 20.9679588,8.45613916 C22.9022792,7.64722278 26.761238,7.86093923 29.2610777,9.52749902 C31.7609174,11.1940588 33.993552,14.6711374 34.0226771,17.265098 C34.0623571,20.7966176 31.9989974,22.8202973 29.5388377,24.7646171 C27.078678,26.7089368 23.2693985,27.5818967 21.2853987,28.1770966 C19.301399,28.7722965 19.460119,31.0340563 19.460119,31.0340563 L19.142679,31.1530962 L19.063319,32.978376 L17.8729192,32.978376 L17.7538792,31.2324562 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68832951,6.96642772 L2.6,5.85291859 L3.50160169,4.93045742 L4.5899312,6.04396655 L7.56506498,3 L8.46666667,3.92246117 L4.5899312,7.88888889 L3.68832951,6.96642772 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Tabs-/-Driver-Complete",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Driver",
    fill: "#A1AEB7",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Swatches-/-Titanium",
    mask: "url(#mask-2)",
    fill: "#616A70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    x: 0,
    y: 0,
    width: 50,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Checkmark",
    transform: "translate(8.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    fill: "#0375BA",
    cx: 5.5,
    cy: 5.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverComplete);
export default __webpack_public_path__ + "static/media/Driver-Complete.123000bc69a9a28a806cd2bad2fafe24.svg";
export { ForwardRef as ReactComponent };